module.exports = __webpack_public_path__ + "img/title-zh.c3c4e5c7.png";